var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horse-lamp"},[_c('div',{staticClass:"lamp",style:({
      transform: 'translateY(' + _vm.step1 * _vm.itemHeight + 'rem)',
      transitionDuration: (_vm.dura1 + "ms")
    })},[_vm._t("lamps",null,{"arr":_vm.arr})],2),_c('div',{staticClass:"lamp",style:({
      transform: 'translateY(' + _vm.step2 * _vm.itemHeight + 'rem)',
      transitionDuration: (_vm.dura2 + "ms")
    })},[_vm._t("lamps",null,{"arr":_vm.arr})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }